export const Tipo = {
  0: 'Online',
  1: 'Presencial',
  2: 'Online e Presencial'
}

export const Status = {
  0: {titulo: 'Rascunho', class: 'light'},
  1: {titulo: 'Em Breve', class: 'light'},
  2: {titulo: 'Em Loteamento', class: 'warning'},
  3: {titulo: 'Ver Mais', class: 'info'},
  4: {titulo: 'Aberto para Lances', class: 'info'},
  5: {titulo: 'Aberto para Proposta', class: 'primary'},
  6: {titulo: 'Em Leilão', class: 'success'},
  99: {titulo: 'Encerrado', class: 'dark'},
  98: {titulo: 'Suspenso', class: 'danger'}
}



// WEBPACK FOOTER //
// ./src/domain/leiloes/helpers/LeilaoStatus.js